import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PrioritySelectItem } from 'src/app/data/models/IncidentReport/incident-report.model';
import { Priority } from 'src/app/data/models/sources/source';

@Injectable({
  providedIn: 'root'
})
export class PriorityService {

  constructor(private http: HttpClient) { }

  GetAllPriorities(): Observable<PrioritySelectItem[]> {
    return this.http.get<PrioritySelectItem[]>('/Priority/GetAllPriorities/');
  }

  getPriorities(): Observable<Priority[]> {
    return this.http.get<Priority[]>('/Priority');
  }
}

